import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";



const CertificateInformation2 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";

    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };


    return (

    
        



        <div className="container mt-1 p-3 mb-1" >


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}
                    >
                       Certificate Course in Financial Accounting

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>
            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col >
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%" }}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in Financial Accounting
                </h5>
                <p>
                    HKCL Financial Accounting offers detailed knowledge of Tally ERP9.<br />   </p>

                The course covers the following aspects:<br />
                <ul>
                    <li>Accounting voucher entries including voucher configuration and setup</li>
                    <li>Inventory setup and advanced inventory configuration</li>
                    <li> Concepts and applications of VAT, Service Tax, TDS, TCS and Excise</li>
                    <li> Advanced accounting transaction recording, inclusive of Industrial Accounting, Indirect Taxation and various statutory forms for tax filing requirements</li>
                    <li> Payroll management and transactions</li>
                    <li> Report generation and Financial Analysis</li>
                    <li>Application of all the above aspects in Tally</li>
                </ul>

            </div>
            <hr />
            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>
            <p>We are launching a new course with Tally Prime version in comparison to the previous course with Tally version 9 for several important reasons:</p>
            <ul>
                <li><b>Stay Relevant:</b> Tally Prime represents the latest iteration of Tally's software, incorporating significant enhancements, improvements, and modernization. It is essential for our learners to be up to date with the latest software versions to remain competitive in the field.</li>
                <li><b>Enhanced Features:</b> Tally Prime introduces new features and functionalities that are not available in Tally version 9. These enhancements can streamline accounting processes, improve efficiency, and offer a more comprehensive learning experience.</li>
                <li><b>Adaptation to Industry Standards:</b> Many businesses and organizations have upgraded to Tally Prime, making it the industry standard. By offering a course on Tally Prime, we ensure that our learners are prepared to meet the demands of the job market and work effectively in real-world scenarios.</li>
                <li><b> Improved User Experience:</b> Tally Prime offers a more user-friendly and intuitive interface compared to Tally version 9. Teaching with the latest software ensures that our learners have a smoother and more enjoyable learning experience.</li>
                <li><b>Future-Proofing:</b> By focusing on Tally Prime, we future-proof our course content. This means that our learners will acquire skills that are relevant not only in the present but also as the software continues to evolve.</li>
                <li> In summary, launching a new course with Tally Prime is essential to provide our learners with the most current and valuable skills, aligning our offerings with industry standards and enhancing the overall quality of education we provide.</li>
            </ul>
            <hr />
            <div>
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> Financial Accounting course is jointly certified by CDOE GJUST and HKCL</li>
                </ul>
                <hr />
            </div>
           
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                    
                    <ol>
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                       
                    </ol>
                </p>
            </div>
            <hr />

            <h5>Syllabus</h5>
            <div className='p-4' >

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7"> Tally Prime with GST</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li>Introduction to Accounting</li>
                                <li>Introduction of Tally Prime</li>
                                <li>Maintaining Data in Tally Prime</li>
                                <li>Accounting Master Setup</li>
                                <li>Inventory Master Setup</li>
                                <li>Voucher Types & Chart of Accounts</li>
                                <li>Multi Master & Preview of Financial</li>
                                <li>Statements in Tally</li>
                                <li>Accounting Voucher - Receipt & Payment</li>
                                <li>Advance Accounting & Inventory Voucher</li>
                                <li>Financial Statements</li>
                                <li>Bill-wise Transactions</li>
                                <li>Bill-wise Outstanding’s Reports</li>
                                <li>Banking in Tally Prime</li>
                                <li> Multi-Currency</li>
                                <li>Purchase Order Process</li>
                                <li> Advance Purchase Order</li>
                                <li> Sales Order</li>
                                <li> Advance Sales Order</li>
                                <li> Advance Inventory</li>
                                <li>Accounting & Inventory Case Study</li>
                                <li>Manufacturing Process</li>
                                <li>Case Study - Batchwise Manufacturing</li>
                                <li> POS Voucher and Other Vouchers</li>
                                <li>Group Company Creation</li>
                                <li>Data Management</li>
                                <li> Data Export Import</li>
                                <li>Tally Remote Access</li>
                                <li>Payroll Setup</li>
                                <li>Payroll Transaction</li>
                                <li>Payroll Reports</li>
                                <li>GST Introduction</li>
                                <li>GST Master Setup in Tally</li>
                                <li> GST - Intrastate Supply</li>
                                <li>GST - Interstate Supply</li>
                                <li>GST Advance Transaction & Reports</li>
                                <li>TDS Compliance</li>
                                <li>Case Study - GST & TDS</li>
                                <li>Year End Audit Transaction</li>
                                <li>Tally Report - Accounting</li>
                                <li>Tally Report - Inventory & Others</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

            </div>
            <hr />







            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    
    );
}
export default CertificateInformation2;